import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import requests from "../../api/Requests";
import "./Banner.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Banner() {
	const [movies, setMovie] = useState([]);

	// Return one random movie
	// useEffect(() => {
	// 	async function fetchDate() {
	// 		const request = await axios.get(requests.fetchNetflixOriginals);
	// 		setMovie(
	// 			request.data.results[
	// 				Math.floor(Math.random() * request.data.results.length - 1)
	// 			]
	// 			);
	// 		return request;
	// 	}
	// 	fetchDate();
	// }, []);

	// Return one random movie
	useEffect(() => {
		async function fetchDate() {
			const request = await axios.get(requests.fetchNetflixOriginals);
			setMovie(request.data.results);
			console.log(request.data.results);
			return request;
		}
		fetchDate();
	}, []);

	function truncate(str, n) {
		return str?.length > n ? str.substr(0, n - 1) + "..." : str;
	}

	const opts = {
		autoplay: true,
		infinite: true,
		autoplaySpeed: 3000,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnFocus: true,
		pauseOnHover: true,
	};

	return (
		<>
			<Slider {...opts}>
				{movies.map((movie) => (
					<div className="slide-itm" key={movie.id}>
						<div
							className="slider-content banner"
							style={{
								backgroundSize: "cover",
								backgroundImage: `url("https://image.tmdb.org/t/p/original/${
									movie?.backdrop_path || movie?.poster_path
								} ")`,
								backgroundPosition: "center center",
							}}
						>
							<div className="banner__contents">
								<h1 className="banner__title">
									{movie.title ||
										movie?.name ||
										movie?.original_name}
								</h1>
								<h1 className="banner__description">
									{truncate(movie?.overview, 250)}
								</h1>
								<div className="banner__buttons">
									<button className="banner__button">
										Play
									</button>
									<button className="banner__button">
										My List
									</button>
								</div>
							</div>

							<div className="banner--fadeBottom" />
						</div>
					</div>
				))}
			</Slider>

			{/* <header
				className="banner"
				style={{
					backgroundSize: "cover",
					backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
					backgroundPosition: "center center",
				}}
			>
				<div className="banner__contents">
					<h1 className="banner__title">
						{movie.title || movie?.name || movie?.original_name}
					</h1>
					<h1 className="banner__description">
						{truncate(movie?.overview, 250)}
					</h1>
					<div className="banner__buttons">
						<button className="banner__button">Play</button>
						<button className="banner__button">My List</button>
					</div>
				</div>

				<div className="banner--fadeBottom" />
			</header> */}
		</>
	);
}

export default Banner;
